import * as React from "react";

const SvgComponent = (props) => (
  <svg width="74" height="70" viewBox="0 0 74 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.20156 0.100098H69.8016C72.0566 0.100098 73.9016 1.9451 73.9016 4.2001V69.8001L0.101562 69.7181V4.2001C0.101562 1.9451 1.94656 0.100098 4.20156 0.100098ZM20.6016 4.2001L12.4016 16.5001H16.5016L24.7016 4.2001H20.6016ZM37.0016 4.2001H32.9016L24.7016 16.5001H28.8016L37.0016 4.2001ZM49.3016 4.2001H45.2016L37.0016 16.5001H41.1016L49.3016 4.2001ZM61.6016 4.2001H57.5016L49.3016 16.5001H53.4016L61.6016 4.2001ZM65.7016 61.6001V20.6001H8.30156V61.6001H65.7016ZM28.8016 24.7001L53.4016 41.1001L28.8016 57.5001V24.7001Z"
      fill="#959DA5"
    />
  </svg>
);

export default SvgComponent;
